import { type MutableRefObject, useCallback, useRef } from 'react';

export type JoinStreamSignal = {
  signalRef: MutableRefObject<{ threadId: string } | null>;
  setJoin: (threadId: string) => void;
  clearJoin: () => void;
};

export function useJoinStreamSignal(): JoinStreamSignal {
  const signalRef = useRef<{ threadId: string } | null>(null);

  const setJoin = useCallback((threadId: string) => {
    signalRef.current = { threadId };
  }, []);

  const clearJoin = useCallback(() => {
    signalRef.current = null;
  }, []);

  return { signalRef, setJoin, clearJoin };
}
